var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.falg)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.download()}}},[_vm._v("Android手机APP下载")]):_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.download()}}},[_vm._v("苹果手机APP下载")])])
}
var staticRenderFns = []

export { render, staticRenderFns }